export const sanitizeOpenLinkUrl = (value: string): string => {
  if (!value) return value;

  // Only decode ampersand entities commonly injected by translations
  const decodedEntities = value
    // Named ampersand
    .replace(/&amp;/gi, '&')
    // Numeric decimal ampersand
    .replace(/&#0*38;/gi, '&')
    // Numeric hex ampersand
    .replace(/&#x0*26;/gi, '&');

  return decodedEntities
    .trim()
    .replace(/^["']|["']$/g, '')
    .replace(/([?&])amp;/g, '$1');
};
